const angular = require('angular');
const app = angular.module('learn-directives');

app.directive('readingTime', ['$translate', function($translate) {
    return {
      restrict: "A",
      scope: {
        readingTime: "=",
        readingText: "="
      },
      link: function(scope, element, attrs) {

        var initialize = function() {
          var readingTime = function(text) {
            if (!angular.isString(text)) {
              return '';
            }
            var words = text.trim().split(/\s+/g).length;
            var wordsPerSecond = 270 / 60;
            var totalReadingTimeSeconds = words / wordsPerSecond;
            var readingTimeMinutes = Math.round(totalReadingTimeSeconds / 60);
            return readingTimeMinutes > 0 ? readingTimeMinutes + ' min' : scope.angTranslation;
          };

          scope.readingTime = readingTime(scope.readingText);

        };

        $translate(['edit.article.lessThanAMinute']).then(function(translations) {
          scope.angTranslation = translations['edit.article.lessThanAMinute'];

          if (scope.readingText) {
            initialize();
          }

          var textWatch = scope.$watch('readingText', function(newVal, oldVal) {
            if (!newVal || newVal === oldVal) {
              return;
            }
            initialize();
          });

        });

      }
    };
  }]);
